import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { useAppStore } from '../store';
import type { Task } from '../types';
import type { CalendarNote } from '../types/calendar';

export function useSearchableTasks() {
  const spaceId = useAppStore((s) => s.currentSpaceId);
  const { data } = useQuery({
    queryKey: ['tasks', 'search', spaceId],
    queryFn: () => api.tasks.list({ spaceId }),
  });
  return (data ?? []) as Task[];
}

export function useSearchCalendarNotes(query: string) {
  return useQuery<CalendarNote[]>({
    queryKey: ['calendar-notes', 'search', query],
    queryFn: () => api.calendarNotes.search(query),
    enabled: query.trim().length > 0,
  });
}
